import React from 'react';
import { Section } from './ui/Section';
export function TruthSection() {
  return <Section background="olive-light" className="text-center" data-id="element-102">
      <h2 className="text-3xl font-bold text-[#2C2C2C] mb-8" data-id="element-103">
        La verdad incómoda (sin culpa)
      </h2>

      <div className="max-w-2xl mx-auto" data-id="element-104">
        <p className="text-2xl font-serif text-[#D4735E] mb-8" data-id="element-105">
          No necesitas más fuerza de voluntad. <br data-id="element-106" />
          Necesitas menos fricción.
        </p>

        <p className="text-lg text-[#5A5A5A] leading-relaxed" data-id="element-107">
          Cuando el estrés sube y el sueño se rompe, tu cuerpo busca alivio
          rápido: azúcar, harina, snack, "algo".
          <br data-id="element-108" />
          <br data-id="element-109" />
          <span className="font-semibold text-[#2C2C2C]" data-id="element-110">
            No porque seas débil. Porque estás agotada.
          </span>
        </p>
      </div>
    </Section>;
}